/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PaymentTermResponse } from '../../models/payment-term-response';

export interface GetPaymentTerms$Params {
}

export function getPaymentTerms(http: HttpClient, rootUrl: string, params?: GetPaymentTerms$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<PaymentTermResponse>>> {
  const rb = new RequestBuilder(rootUrl, getPaymentTerms.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<PaymentTermResponse>>;
    })
  );
}

getPaymentTerms.PATH = '/payment-terms';
